import {
  NumberType,
  formatAmount,
  formatNumber,
  getTimeZone,
} from '@vgrubs/components';
import { DateTime } from 'luxon';

export type GamesRange = { from: string; to: string; timeZone: string };

/** The Finances tab's range as whole days, the same as its other cards. */
export const gamesRange = (from: string, to: string): GamesRange => ({
  from: DateTime.fromISO(from).startOf('day').toISODate() || '',
  to: DateTime.fromISO(to).endOf('day').toISODate() || '',
  timeZone: getTimeZone,
});

export const usd = (cents: number) => formatAmount(cents, NumberType.USD);

export const count = (value: number) => formatNumber(value);

export const plural = (value: number, word: string) =>
  `${count(value)} ${word}${value === 1 ? '' : 's'}`;

/** Of `revenue`, to one decimal; null when MyChips paid nothing. */
export const shareOf = (part: number, revenue: number) =>
  revenue > 0 ? Math.round((part / revenue) * 1000) / 10 : null;

/** "+1 •••• 6113": the country code and the last four digits. */
export const maskPhone = (phone: string) => {
  const digits = phone.replace(/\D/g, '');
  if (digits.length < 4) return phone;
  // The national number of a US / Canada E.164 is ten digits.
  const country = digits.length > 10 ? `+${digits.slice(0, -10)} ` : '';
  return `${country}•••• ${digits.slice(-4)}`;
};
